module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "oxigrafia inner-screen"
  }, [_c('video-page', {
    attrs: {
      "data": _vm.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62795074"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lithografia.vue
// module id = 570
// module chunks = 1